// Angular imports
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

// 3rd party imports
import { classToPlain, plainToClass } from 'class-transformer';

// RxJs imports
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

// Model imports
import { WFEEditorParameterDto } from '../../shared-workflow-module/_models/wfe-editor-parameter-dto';
import { WFECAMStepEditorResultDto } from '../_models/workflow-cam-step/wfe-cam-step-editor-result-dto';
import { WFEWorkflowRawDto } from '../../shared-workflow-module/_models/wfe-workflow-raw-dto';
import { SubCategoryByGlAccountParametersDto } from '../../cirabooks/shared-cirabooks-module/_models/common/subcategory-by-gl-account-parametere-dto';
import { GLSubcategorySelectorResultDto } from '../../cirabooks/shared-cirabooks-module/_models/common/gl-account/glsubcategory-selector-result-dto';
import { DimensionSelectorResultDto } from '../../cirabooks/shared-cirabooks-module/_models/common/dimensions/dimension-selector-result-dto';
import { WFEBudgetedGLAccountSelectorResultDto } from '../../shared-workflow-module/_models/wfe-budgeted-gl-account-selector-result-dto';
import { WFEBudgetedGLAccountSelectorParameterDto } from '../../shared-workflow-module/_models/wfe-budgeted-gl-account-selector-parameter-dto';
import { WFEDenyCAMStepParameterDto } from '../_models/workflow-cam-step/wfe-deny-cam-step-parameter-dto';
import { WFEApproveCamAcctStepParametersDto } from '../_models/common/wfe-approve-cam-acct-step-parameters-dto';

// constant imports
import { URLConstants } from '../../_constants/url-constants';

@Injectable({
    providedIn: 'root'
})
export class WorkflowCamStepService {
    constructor(private readonly httpClient: HttpClient) {}

    getWorflowMoveToCAMEditor(baseParams: WFEEditorParameterDto): Observable<WFECAMStepEditorResultDto> {
        baseParams.clearCache = true;
        const url = `${URLConstants.ccWorkflowEditorBaseApiUrl}cam/editor${baseParams.getQueryString()}`;

        return this.httpClient
            .get<WFECAMStepEditorResultDto>(url)
            .pipe(map((response) => plainToClass(WFECAMStepEditorResultDto, response)));
    }

    approve(baseParams: WFEApproveCamAcctStepParametersDto): Observable<any> {
        return this.httpClient.put(`${URLConstants.ccWorkflowEditorBaseApiUrl}cam/approve`, classToPlain(baseParams));
    }

    getSubCategories(baseParams: SubCategoryByGlAccountParametersDto): Observable<GLSubcategorySelectorResultDto[]> {
        const url = `${URLConstants.ccWorkflowEditorBaseApiUrl}subcategories${baseParams.getQueryString()}`;

        return this.httpClient
            .get<GLSubcategorySelectorResultDto[]>(url)
            .pipe(map((response) => plainToClass(GLSubcategorySelectorResultDto, response)));
    }

    getDimensions(baseParams: SubCategoryByGlAccountParametersDto): Observable<DimensionSelectorResultDto[]> {
        const url = `${URLConstants.ccWorkflowEditorBaseApiUrl}dimensions${baseParams.getQueryString()}`;

        return this.httpClient
            .get<DimensionSelectorResultDto[]>(url)
            .pipe(map((response) => plainToClass(DimensionSelectorResultDto, response)));
    }

    getGLAccounts(
        baseParams: WFEBudgetedGLAccountSelectorParameterDto
    ): Observable<WFEBudgetedGLAccountSelectorResultDto[]> {
        const url = `${URLConstants.ccWorkflowEditorBaseApiUrl}glaccounts${baseParams.getQueryString()}`;

        return this.httpClient
            .get<WFEBudgetedGLAccountSelectorResultDto[]>(url)
            .pipe(map((response) => plainToClass(WFEBudgetedGLAccountSelectorResultDto, response)));
    }

    placeInReview(baseParams: WFEWorkflowRawDto): Observable<any> {
        return this.httpClient.put(`${URLConstants.ccWorkflowEditorBaseApiUrl}cam/inreview`, classToPlain(baseParams));
    }

    denyCam(baseParams: WFEDenyCAMStepParameterDto): Observable<any> {
        return this.httpClient.put(`${URLConstants.ccWorkflowEditorBaseApiUrl}cam/deny`, classToPlain(baseParams));
    }
}
